import { useState, useCallback } from 'react';

export function useApiState() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const reset = useCallback(() => {
    setLoading(false);
    setError('');
  }, []);

  return { loading, setLoading, error, setError, reset };
} 